































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import providers from "@/lib/api";
import { Debounce } from "@/lib/decorators";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues, PostFileData } from "@/types";
import BaseForm from "@/components/BaseForm";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import EditPostDropZone from "../EditPostDropZone";
import PostFileThumbnail from "../PostFileThumbnail";

@Component({
  name: "EventPostEditView",
  components: { BaseInputFile, PostFileThumbnail, BaseForm, BaseIcon, EditPostDropZone },
})
export default class EventPostEditView extends Vue {
  @Prop({ required: true })
  public readonly postData!: ContentSet;

  @Prop({ required: true })
  public readonly fileList!: PostFileData[];

  public valid = false;

  public hint = "";

  public invalidField = false;

  public values: FormValues = {
    link: "",
  };

  public get cover() {
    return this.fileList[0] || null;
  }

  public get fields(): FormFields {
    return [
      {
        name: "link",
        label: $t("Link to event"),
        hint: this.hint || $t("Users will get access to this meeting link after the purchase"),
        invalidField: this.invalidField,
        rules: ["required"],
        validationMode: "aggressive",
      },
    ];
  }

  @Watch("values")
  public watchValuesChanged({ link }: FormValues) {
    if (!this.valid || !link) return;
    this.hint = $t("Validating...");
    this.invalidField = false;
    this.sendEventData(link);
  }

  @Debounce(500)
  public async sendEventData(link: string) {
    try {
      providers.EventPostProvider.setReceiveErrors(false);
      await providers.EventPostProvider.update({
        data: {
          postId: this.postData.id,
          link,
        },
      });
      this.hint = "";
    } catch (e) {
      this.hint = $t("The link field must be a valid url");
      this.invalidField = true;
    }
  }

  public async getData() {
    const data = await providers.EventPostProvider.find({ postIds: [this.postData.id] });
    this.$set(this.values, "link", (data.find(i => i.postId === this.postData.id) || { link: "" }).link);
  }

  public created() {
    this.getData();
  }
}
